/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint max-lines: ["error", 740] */
import { API_METHODS, PRODUCTS_URI, SAVE_FOR_LATER, SHOP_THIS_STORE_URI } from './api.constants';

const endpoints = {
  graphQL: {
    int: 'https://niebw6f7lfeorgk6adlvicfnca.appsync-api.us-east-2.amazonaws.com/graphql',
    uat: 'https://vftt2fuvm5eu5jat3ounglwv3a.appsync-api.us-east-2.amazonaws.com/graphql',
    perf: 'https://563k2dzbojbsvnaaljusrz4y44.appsync-api.us-east-2.amazonaws.com/graphql',
    sandbox: 'https://lwmlzhk7g5grdgtbzozpgsb3lm.appsync-api.us-east-2.amazonaws.com/graphql',
  },
  getAddressList: {
    method: API_METHODS.GET,
    URI: 'v2/account/getAddressFromBook',
  },
  verifyAddress: {
    method: API_METHODS.GET,
    // TODO - Use MELISSA_KEY from config file
    URI: 'https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify',
  },
  emailVerification: {
    method: 'post',
    URI: 'https://bpi.briteverify.com/api/public/v1/fullverify',
    JSONP: true,
    reqTimeout: 6000,
    authKey: 'b049d05a-f8ad-45ef-bd1b-c2f1931cb86c',
  },
  addSmsSignup: {
    method: 'post',
    URI: 'stateful/account-ext/v2/smsSignUp',
  },
  addEmailSignup: {
    method: 'post',
    URI: 'stateful/account/v2/addSignUpEmail',
  },
  addEmailSignupPLCC: {
    method: 'post',
    URI: 'stateful/plcc/v2/addSignUpEmail',
  },
  addEmailSignupForWcs: {
    method: 'post',
    URI: 'v2/store/addSignUpEmail',
  },
  getOrderDetails: {
    method: API_METHODS.GET,
    URI: 'v2/checkout/getOrderDetails',
  },
  fullDetails: {
    method: API_METHODS.GET,
    URI: 'v2/checkout/cart',
  },
  addCreditCard: {
    method: API_METHODS.POST,
    URI: 'v2/account/addCreditCardDetails',
  },
  instantCreditApplication: {
    method: 'POST',
    // URI: 'stateful/account/v2/plccWIC',
    URI: 'stateful/plcc/v2/plccWIC',
  },
  savePlcc: {
    method: 'POST',
    URI: 'v2/account/savePLCC',
  },
  updateCreditCard: {
    method: API_METHODS.POST,
    URI: 'v2/account/modifyCreditCardDetails',
  },
  addAddress: {
    method: API_METHODS.POST,
    URI: 'v2/account/addAddress',
  },
  addUpdateShippingAddress: {
    method: API_METHODS.POST,
    URI: 'stateful/checkout/v2/shippingAddress',
  },
  addPaymentInstruction: {
    method: 'POST',
    URI: 'v2/checkout/addPaymentInstruction',
  },
  addPaymentInstructionSFCCC: {
    method: 'POST',
    URI: 'stateful/checkout/v2/payment-instruments',
  },
  deletePaymentInstruction: {
    method: 'POST',
    URI: 'v2/checkout/deletePaymentInstruction',
  },
  updateAddress: {
    method: 'put',
    URI: 'v2/wallet/updateAddress',
  },
  updateMultiSelectItemsToRemove: {
    method: 'PUT',
    URI: 'v2/cart/deleteMultipleOrderItems',
  },
  updateOrderItem: {
    method: 'PUT',
    URI: 'v2/cart/updateOrderItem',
  },
  createAccount: {
    method: API_METHODS.POST,
    URI: 'v2/wallet/addCustomerRegistration',
  },
  createAccountPLCC: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v1/signUpPlcc',
  },
  logon: {
    method: API_METHODS.POST,
    URI: 'v2/account/logon',
  },
  emailVerify: {
    method: API_METHODS.GET,
    URI: 'stateful/account/v2/auth/email/',
  },
  getRegisteredUserDetailsInfo: {
    method: API_METHODS.GET,
    URI: 'v2/account/getRegisteredUserInfo',
  },
  getListofDefaultWishlist: {
    method: API_METHODS.GET,
    URI: 'v2/wishlist/getWishListbyId?itemSummary=true',
  },
  getCouponList: {
    method: API_METHODS.GET,
    URI: 'v2/account/getAddressFromBook',
  },
  logout: {
    method: API_METHODS.DELETE,
    URI: 'v2/account/logout',
  },
  getPointsHistory: {
    method: API_METHODS.GET,
    URI: 'stateful/account/v2/getMyPointHistory',
  },
  bonusPoints: {
    method: API_METHODS.GET,
    URI: 'stateful/account/v2/bonusDay',
  },
  applyBonusPoints: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/bonusDay',
  },
  addCoupons: {
    method: 'post',
    URI: 'v2/checkout/coupons',
  },
  addAirmilesBanner: {
    method: 'put',
    URI: 'stateful/cart/v2/airmiles',
  },
  requestPassword: {
    method: 'put',
    URI: 'v2/account/resetPassword',
  },
  requestPasswordPost: {
    method: 'post',
    URI: 'v2/account/resetPassword',
  },
  forgotPasswordMS: {
    method: 'post',
    URI: 'stateful/account/v2/auth/forgotPassword',
  },
  updateProfileInfo: {
    method: 'put',
    URI: 'stateful/account/v2/updateUser',
  },
  getExtraPoints: {
    method: 'GET',
    URI: 'stateful/account/v2/points/waysToEarn',
  },
  getEarnedPointsNotication: {
    method: 'GET',
    URI: 'stateful/account/v2/wallet/points/nontransactional/current',
  },
  getGifCardBalance: {
    method: API_METHODS.POST,
    URI: 'stateful/checkout/v2/giftCardBalance',
  },
  setDefaultPayment: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/makeDefault',
  },
  getCardList: {
    method: API_METHODS.GET,
    URI: 'v2/account/getCreditCardDetails',
  },
  addGiftCard: {
    method: API_METHODS.POST,
    URI: 'v2/account/addCreditCardDetails',
  },
  addStoreDetails: {
    method: API_METHODS.POST,
    URI: 'stateful/checkout/v2/addStoreDetails/',
  },
  setDefaultShippingAddress: {
    method: API_METHODS.PUT,
    URI: 'v2/wallet/updateAddress',
  },
  deleteAddress: {
    method: API_METHODS.DELETE,
    URI: 'v2/account/deleteAddressDetails',
  },
  addShipToStore: {
    method: API_METHODS.POST,
    URI: 'v2/cart/addShipToStore',
  },
  getProductDetails: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS,
    unbxd: true,
    unbxdCustom: true,
    authHeaderRequired: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  getProductSkuInfo: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS_BY_SEARCH,
    unbxd: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  getProductsByOutfits: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS_BY_OUTFITS,
  },
  getProductviewbyCategory: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS_VIEW_BY_CATEGORY,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  getProductsBySearchTerm: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS_BY_SEARCH,
    unbxd: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  getProductInfoById: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS_BY_SEARCH,
    unbxd: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  getProductInfoForTranslationByPartNumber: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS,
    unbxd: true,
    unbxdCustom: true,
    authHeaderRequired: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  deleteCreditCardOnAccount: {
    method: API_METHODS.POST,
    URI: 'v2/account/deleteCreditCardDetails',
  },
  addProductToCart: {
    method: API_METHODS.POST,
    URI: 'v2/cart/addProductToCart',
  },
  addItemToCart: {
    method: API_METHODS.POST,
    URI: 'stateful/cart/v2/items',
  },
  getCart: {
    method: 'GET',
    URI: 'stateful/cart/v2/carts',
  },
  priceDropUpdate: {
    method: API_METHODS.POST,
    URI: 'stateful/cart/v2/price-drop',
  },
  addOrderBopisItem: {
    method: API_METHODS.POST,
    URI: 'v2/bopis/createBopisOrder',
  },
  removeCouponOrPromo: {
    method: 'POST',
    URI: 'v2/checkout/removePromotionCode',
  },
  getContactPreferences: {
    method: 'GET',
    URI: 'v2/account/preferences',
  },
  setContactPreferences: {
    method: 'PUT',
    URI: 'v2/account/preferences',
  },
  getAllOffers: {
    method: API_METHODS.GET,
    URI: 'v2/wallet/getAllCoupons',
  },
  getPromotionDetails: {
    method: API_METHODS.POST,
    URI: 'v2/wallet/getPromotionDetails',
  },
  getCouponDetailsCsh: {
    method: API_METHODS.POST,
    URI: 'stateful/wallet/v2/getCouponDetailsCsh',
  },
  getCouponDetails: {
    method: API_METHODS.POST,
    URI: 'v2/wallet/getPromotionDetails',
  },
  giftOptionsCmd: {
    method: API_METHODS.GET,
    URI: 'v2/checkout/giftOptionsCmd',
  },
  orderLookUp: {
    method: API_METHODS.GET,
    URI: 'v2/account/orderLookUp',
  },
  getUnqualifiedItems: {
    method: 'GET',
    URI: 'v2/cart/getUnqualifiedItems',
  },
  getShipmentMethods: {
    method: 'GET',
    URI: 'v2/checkout/getShipmentMethods',
  },
  getDefaultShipmentMethods: {
    method: 'GET',
    URI: 'v2/checkout/getDefaultShipmentMethods',
  },
  getSFCCAuthToken: {
    method: 'POST',
    URI: 'stateful/account/v2/auth/token',
  },
  sfccLogon: {
    method: 'POST',
    URI: 'stateful/account/v2/auth/login',
  },
  plccLogin: {
    method: 'POST',
    URI: 'stateful/account/v2/auth/loginPlcc',
  },
  updateShippingMethodSelection: {
    method: 'PUT',
    URI: 'v2/checkout/updateShippingMethodSelection',
  },
  updateShippingMethodSelectionSFCC: {
    method: 'PUT',
    URI: 'stateful/checkout/v2/shippingMethod',
  },
  getChildren: {
    method: 'GET',
    URI: 'stateful/account-ext/v2/getBirthdaySavings',
  },
  updateUserSurvey: {
    method: 'POST',
    URI: 'stateful/account-ext/v2/saveUserSurvey',
  },
  updatePaymentInstruction: {
    method: 'PUT',
    URI: 'v2/checkout/updatePaymentInstruction',
  },
  deleteChild: {
    method: 'DELETE',
    URI: 'stateful/account-ext/v2/deleteBirthdaySavings',
  },
  addChild: {
    method: 'POST',
    URI: 'stateful/account-ext/v2/birthdaysavingprocess',
  },
  addGiftOptions: {
    method: 'POST',
    URI: 'v2/checkout/addGiftOptions',
  },
  internationalCheckoutSettings: {
    method: 'POST',
    URI: 'stateful/borderfree/v2/envoi-checkout',
  },
  paypalLookUp: {
    method: 'GET',
    URI: 'v2/checkout/TCPPayPalCCLookUpRESTCmd',
  },
  newpaypalLookUp: {
    method: 'POST',
    URI: 'stateful/checkout/v2/paypalLookup/',
  },
  paypalAuth: {
    method: 'GET',
    URI: 'v2/checkout/TCPPayPalCCAuthenticationRESTCmd',
  },
  searchBarApi: {
    method: 'GET',
    URI: PRODUCTS_URI.PRODUCTS_AUTOSUGGEST,
    unbxd: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  getFavoriteStore: {
    method: 'GET',
    URI: 'v2/store/getFavouriteStoreLocation',
  },
  findStoresByCoordinates: {
    method: 'GET',
    URI: 'v2/store/findStoresbyLatitudeandLongitude',
  },
  setFavoriteStore: {
    method: 'POST',
    URI: 'v2/store/addFavouriteStoreLocation',
  },
  getSocialAccountsInfo: {
    method: 'GET',
    URI: 'stateful/account-ext/v2/getSocialPreferences',
  },
  saveSocialAccountsInfo: {
    method: 'PUT',
    URI: 'stateful/account-ext/v2/saveSocialPreferences',
  },
  getVenmoClientToken: {
    method: 'GET',
    URI: 'stateful/checkout/v2/venmo/token',
  },
  getPaySecureClientToken: {
    method: 'GET',
    URI: 'stateful/payment/v2/creditCard/sessionId',
  },
  tokenizeCard: {
    method: 'POST',
    URI: 'ClientTokenizeCardRequest',
  },
  adyenSessions: {
    method: 'POST',
    URI: 'stateful/checkout/v2/adyen/sessions',
  },
  adyenApplePaySessions: {
    method: 'POST',
    URI: 'stateful/payment/v2/applepay/session',
  },
  adyenPayments: {
    method: 'POST',
    URI: 'stateful/checkout/v2/adyen/payments',
  },
  adyenUpdatePaypalOrder: {
    method: 'POST',
    URI: 'stateful/checkout/v2/adyen/paypal/order',
  },
  creditCardOffline: {
    method: 'POST',
    URI: 'stateful/payment/v2/cc/offline',
  },
  getAppleClientToken: {
    method: 'GET',
    URI: 'stateful/checkout/v2/applePay/token',
  },
  getAllSfl: {
    method: 'GET',
    URI: SAVE_FOR_LATER,
  },
  updateSflItem: {
    method: 'PUT',
    URI: SAVE_FOR_LATER,
  },
  deleteSflItem: {
    method: 'DELETE',
    URI: SAVE_FOR_LATER,
  },
  addSflItem: {
    method: 'POST',
    URI: SAVE_FOR_LATER,
  },
  getStoreandProductInventoryInfo: {
    method: 'GET',
    URI: 'v2/vendor/getStoreAndProductInventoryInfo',
  },
  checkout: {
    method: 'POST',
    URI: 'v2/checkout/addCheckout',
  },
  personalizedCoupons: {
    method: 'POST',
    URI: 'v2/coupons/getOffers',
  },
  updatedPersonalizedCoupons: {
    method: 'POST',
    URI: 'stateful/checkout/v2/getOffers',
  },
  getStoreInfo: {
    method: 'GET',
    URI: 'v2/store/info',
  },
  getNearByStore: {
    method: 'GET',
    URI: 'v2/store/nearBy',
  },
  getBOPISInventoryDetails: {
    method: 'POST',
    URI: 'v2/vendor/getBOPISInvetoryDetails',
  },
  getUserCartStoresAndInventory: {
    method: 'GET',
    URI: 'v2/bopis/getUserBopisStores',
  },
  claimPoints: {
    method: 'POST',
    URI: 'stateful/account/v2/points/claim',
  },
  navigateXHRService: {
    method: 'POST',
    URI: 'site/v1.0/navigatexhr',
  },
  postNavigateService: {
    method: 'POST',
    URI: 'site/v1.0/navigate',
  },
  postV2NavigateService: {
    method: 'GET',
    URI: 'stateless/navigation/v2/navigate',
  },
  getStyliticsProductViewById: {
    method: API_METHODS.GET,
    URI: 'https://widget-api.stylitics.com/api/outfits',
    serverTimeout: 15000,
    clientTimeout: 30000,
  },
  getStyliticsProductsByTag: {
    method: API_METHODS.GET,
    URI: 'https://widget-api.stylitics.com/api/outfits',
    serverTimeout: 15000,
    clientTimeout: 30000,
  },
  getDetailedOrderHistory: {
    method: 'GET',
    URI: 'v2/wallet/getPointsAndOrderHistory',
  },
  getAccountOrders: {
    method: 'GET',
    URI: 'v1/account/orders',
  },
  addOrUpdateWishlist: {
    method: 'PUT',
    URI: 'v2/wishlist/addOrUpdateWishlist',
  },
  getTwitterAuthToken: {
    method: 'POST',
    URI: 'stateful/account-ext/v2/twitterRequestToken',
  },
  getTwitterAccessToken: {
    method: 'POST',
    URI: 'stateful/account-ext/v2/twitterAccessToken',
  },
  getListofWishList: {
    method: 'GET',
    URI: 'v2/wishlist/getListOfWishlist',
  },
  getWishListbyId: {
    method: 'GET',
    URI: 'v2/wishlist/getWishListbyId',
  },
  createWishListForUser: {
    method: 'POST',
    URI: 'v2/wishlist/createWishListForUser',
  },
  moveWishListItem: {
    method: 'PUT',
    URI: 'v2/wishlist/moveItemToWishList',
  },
  deleteWishListForUser: {
    method: 'DELETE',
    URI: 'v2/wishlist/deleteWishListForUser',
  },
  editWishList: {
    method: 'PUT',
    URI: 'v2/wishlist/updateWishListForUser',
  },
  deleteWishListItemForUser: {
    method: 'DELETE',
    URI: 'v2/wishlist/deleteItemFromWishList',
  },
  shareWishListForUser: {
    method: 'POST',
    URI: 'stateful/wishlist/v2/shareWishList/email',
  },
  getStoreLocationByCountry: {
    method: 'GET',
    URI: 'v2/store/getStoreLocationByCountry',
  },
  startExpressCheckout: {
    method: 'POST',
    URI: 'v2/checkout/expressCheckout',
  },
  getInstagramAccessToken: {
    method: 'POST',
    URI: 'stateful/account-ext/v2/instagramAuthorization',
  },
  userGroup: {
    method: 'PUT',
    URI: 'v2/account/userGroup',
  },
  updateRTPSdata: {
    method: 'POST',
    URI: 'stateful/plcc/v2/generatePrescreen',
  },
  prescreenApplication: {
    method: 'POST',
    // URI: 'stateful/account/v2/checkoutPreScreen',
    URI: 'stateful/plcc/v2/processPrescreen',
  },
  processPreScreenOffer: {
    method: 'POST',
    URI: 'stateful/plcc/v2/madeOffer',
  },
  getBazaarVoiceRatings: {
    method: API_METHODS.GET,
    URI: 'data/reviews.json?ApiVersion=5.4&Passkey=#pass-key#&Include=Products&Stats=reviews&Filter=ProductId:#product-id#&Limit=#limit#',
    timeout: 30000,
  },
  getBVProductRatings: {
    method: API_METHODS.GET,
    URI: 'data/reviews.json?apiversion=5.4&passkey=',
    timeout: 30000,
  },
  getProductDetailsById: (productId) => {
    return {
      method: API_METHODS.GET,
      URI: `stateless/product/v2/productById/${productId}`,
    };
  },
  getMultiProductsDetails: (productIds) => {
    return {
      method: API_METHODS.GET,
      URI: `stateless/product/v2/products?productIds=${productIds}`,
    };
  },
  pdpApi: {
    method: 'GET',
    URI: 'pdp/v1.0/#style-no#?brand=#brand#&lang=#lang#&site=#site#',
  },
  pdpProductApi: {
    method: 'GET',
    URI: 'pdp/v1.0/products/#style-no#?brand=#brand#&lang=#lang#&site=#site#',
  },
  getAppUpdatedVersion: {
    method: 'GET',
    URI: '/rwd/mobileapp/AppVersion.json',
  },
  getJsonURL: (prefix, brand, file, locale) => {
    const lowerLocale = locale?.toLowerCase();
    if (lowerLocale !== 'en_us' && lowerLocale !== 'en_ca') {
      return { method: 'GET', URI: `${prefix}/${brand}/${file}_${lowerLocale}.json` };
    }
    return { method: 'GET', URI: `${prefix}/${brand}/${file}.json` };
  },
  getAbtestJsonUrl: (brand, siteId) => {
    return { method: 'GET', URI: `rwd/abtest/web/${brand}/${`abtest_${siteId}`}.json` };
  },
  getUSSeoTokenURL: () => {
    return {
      method: 'GET',
      URI: '/usSEOData.config.json',
    };
  },
  getCASeoTokenURL: () => {
    return {
      method: 'GET',
      URI: '/caSEOData.config.json',
    };
  },
  getNoHrefLangSeoTokenURL: () => {
    return {
      method: 'GET',
      URI: '/noHreflang.config.json',
    };
  },
  getAppCouponsURL: (prefix, brand) => {
    return { method: 'GET', URI: `${prefix}/appCoupons-${brand}.json` };
  },
  saveOrUpdateBillingInfo: {
    method: 'PUT',
    URI: 'v2/checkout/billingInformation',
  },
  eDDServiceApi: {
    method: 'POST',
    URI: 'edd/v1.0/item/edd',
  },
  eddPersist: {
    method: 'POST',
    URI: 'v2/checkout/persistEddNode',
  },
  neweddPersist: {
    method: 'PUT',
    URI: 'stateful/checkout/v2/persistEddNode',
  },
  sendOrderEmail: {
    method: 'POST',
    URI: 'stateful/checkout/v2/order/resendEmailConfirmation',
  },
  getItemLevelRefund: {
    method: API_METHODS.PUT,
    URI: 'v1/customerservice/refund/item',
  },
  initiateReturn: {
    method: API_METHODS.PUT,
    URI: 'v1/customerservice/return/order',
  },
  addPickUpPerson: {
    method: API_METHODS.POST,
    URI: 'stateful/customer/v2/order/pickup-person',
  },
  getShipmentStatus: {
    method: API_METHODS.POST,
    URI: 'v1/customerservice/shipmentStatus',
  },
  getRefundStatus: {
    method: 'GET',
    URI: 'v1/customerservice/refund/eligible/sla',
  },
  getCancelStatus: {
    method: API_METHODS.PUT,
    URI: 'v1/customerservice/cancel/order',
  },
  getShipmentDelayedRefundStatus: {
    method: API_METHODS.PUT,
    URI: 'v1/customerservice/refund/shipping',
  },
  createUser: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/user',
  },
  createAccountOtpFlow: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/users',
  },
  logoutUser: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/auth/logout',
  },
  changePassword: {
    method: API_METHODS.PUT,
    URI: 'stateful/account/v2/changePassword',
  },
  changePasswordPLCC: {
    method: API_METHODS.PUT,
    URI: 'stateful/account/v1/changePasswordPlcc',
  },
  requestPasswordMS: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/auth/reset-password',
  },
  emailSmsSignUp: {
    method: API_METHODS.POST,
    URI: 'v2/store/emailSmsSignUp',
  },
  cartSync: {
    method: 'GET',
    URI: 'v2/cart/sfccBasketSync',
  },
  mergeAccountValidateMember: {
    method: API_METHODS.POST,
    URI: 'stateful/loyalty/v2/points/order/validateMember',
  },
  mergeAccountValidateMemberWithLocking: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/validateMember',
  },
  mergeAccountGenerateOTP: (emailAddress) => {
    return {
      method: API_METHODS.GET,
      URI: `stateful/account/v2/generate/otp?emailId=${emailAddress}&featureType=AccountMerge`,
    };
  },
  mergeAccountValidateOTP: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/validate/otp',
  },
  phoneLookupAPI: {
    method: API_METHODS.POST,
    URI: 'v2/account/phoneLookup',
  },
  phoneLookupWithoutMule: {
    method: API_METHODS.GET,
    URI: 'stateful/account/v2/auth/phone',
  },
  calculateEstimatedTaxNewMS: {
    method: API_METHODS.POST,
    URI: 'stateful/tax/v2/calculate',
  },
  calculateEstimatedTax: {
    method: API_METHODS.GET,
    URI: 'stateful/checkout/v2/tax/',
  },
  getServerTime: {
    method: API_METHODS.GET,
    URI: 'servertime',
  },
  getBuyItAgainProducts: {
    method: API_METHODS.GET,
    URI: 'stateful/personalization/v2/buyItAgain',
  },
  sfccStoreLocatorApiURL: {
    method: API_METHODS.GET,
    URI: 'stateless/direct/stores',
  },
  submitBazaarVoiceRatingApi: {
    method: API_METHODS.GET,
    URI: 'data/submitreview.json',
    contentType: 'application/x-www-form-urlencoded',
    timeout: 30000,
  },
  uploadBazaarVoicePhoto: {
    method: API_METHODS.POST,
    URI: 'data/uploadphoto.json',
    timeout: 30000,
  },
  initiateBVRatings: {
    method: API_METHODS.POST,
    URI: 'data/initiateSubmit.json?passkey=#pass-key#&apiVersion=5.4',
    timeout: 30000,
  },
  submitBVRatings: {
    method: API_METHODS.POST,
    URI: 'data/progressiveSubmit.json?passkey=#pass-key#&apiVersion=5.4&Action=submit',
    timeout: 30000,
  },
  createPixleeRatings: {
    method: API_METHODS.POST,
    URI: 'stateful/personalization/v2/reviews',
    timeout: 30000,
  },
  rateAndReview: {
    method: API_METHODS.GET,
    URI: 'stateful/personalization/v2/rateAndReview',
  },
  generateLoginOTP: {
    method: API_METHODS.POST,
    URI: `stateful/account/v2/auth/login/otp`,
  },
  generateCreateAccountOTP: {
    method: API_METHODS.PUT,
    URI: `stateful/account/v2/auth/user/otp`,
  },
  validateLoginOTP: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/auth/otp',
  },
  validateCreateAccountLoginOTP: {
    method: API_METHODS.POST,
    URI: 'stateful/account/v2/auth/user/verify',
  },
  shopThisStoreCategories: {
    method: 'GET',
    URI: SHOP_THIS_STORE_URI.CATEGORIES,
    unbxd: true,
    clientTimeout: 30000,
    serverTimeout: 15000,
  },
  sfccInventoryApiURL: {
    method: API_METHODS.GET,
    URI: 'stateless/direct/inventory',
    timeout: 30000,
  },
  afterPayCheckout: {
    method: API_METHODS.GET,
    URI: 'stateful/checkout/v2/afterpay/checkoutInfo',
  },
  getStatefullItemLevelRefund: {
    method: API_METHODS.PUT,
    URI: 'stateful/customer/v2/refund/item',
  },
  getStatefullShipmentDelayedRefundStatus: {
    method: API_METHODS.PUT,
    URI: 'stateful/customer/v2/refund/shipping',
  },
  getStatefullCancelStatus: {
    method: API_METHODS.PUT,
    URI: 'stateful/customer/v2/cancel/order',
  },
  initiateStateFullReturn: {
    method: API_METHODS.PUT,
    URI: 'stateful/customer/v2/return/order',
  },
  getStatefullShipmentStatus: {
    method: API_METHODS.POST,
    URI: 'stateful/customer/v2/shipmentStatus',
  },
  getStatefullRefundStatus: (orderId) => {
    return {
      method: 'GET',
      URI: `stateful/customer/v2/refund/eligible/sla/${orderId}`,
    };
  },
  chatGpt: {
    method: API_METHODS.POST,
    URI: 'genai/faq',
  },
  submitPixleeRatings: {
    method: API_METHODS.POST,
    URI: 'stateful/personalization/v2/reviews',
    timeout: 30000,
  },
  getEbboOffers: {
    method: API_METHODS.GET,
    URI: 'api/v1/offers',
  },
};

export default endpoints;
